import React, { createContext, useState } from "react";

export const GenerationContext = createContext();

export const GenerationProvider = ({ children }) => {
  const [text, setText] = useState("");
  const [promptValue, setPromptValue] = useState("");
  const [styleValue, setStyleValue] = useState("");
  const [aspectRatio, setAspectRatio] = useState("");
  const [negativePrompt, setNegativePrompt] = useState("");
  const [cfgValue, setCfgValue] = useState("");
  const [seedValue, setSeedValue] = useState("");
  const [stepsValue, setStepsValue] = useState("");
  const [highResolution, setHighResolution] = useState(0);
  const [imageText, setImageText] = useState("");
  const [image, setImage] = useState("");
  const [strength, setStrength] = useState("");
  const [control, setControl] = useState("");
  const [selected, setSelected] = useState("Text To Image");

  return (
    <GenerationContext.Provider
      value={{
        text,
        setText,
        promptValue,
        setPromptValue,
        styleValue,
        setStyleValue,
        aspectRatio,
        setAspectRatio,
        negativePrompt,
        setNegativePrompt,
        cfgValue,
        setCfgValue,
        seedValue,
        setSeedValue,
        stepsValue,
        setStepsValue,
        highResolution,
        setHighResolution,
        imageText,
        setImageText,
        image,
        setImage,
        strength,
        setStrength,
        control,
        setControl,
        selected,
        setSelected,
      }}
    >
      {children}
    </GenerationContext.Provider>
  );
};
